module.exports = __webpack_public_path__ + "static/media/AllYouHavetoDo.4c8f9f02.jpg";